import { cn } from "@/lib/utils";

type FooterProps = {
  onNavigate: (path: string) => void;
  className?: string;
};

export function Footer({ onNavigate, className }: FooterProps) {
  return (
    <footer
      className={cn(
        "border-t border-border/60 bg-muted/30",
        className,
      )}
    >
      <div className="mx-auto max-w-6xl px-6 py-12">
        <div className="flex flex-col items-center justify-between gap-8 sm:flex-row">
          <span className="text-sm text-muted-foreground">
            © {new Date().getFullYear()} Monobundle Inc. All rights reserved.
          </span>
          <nav className="flex gap-8" aria-label="Footer">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/");
              }}
              className="text-sm text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              Home
            </a>
            <a
              href="/about"
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/about");
              }}
              className="text-sm text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              About
            </a>
            <a
              href="/service"
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/service");
              }}
              className="text-sm text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              Service
            </a>
            <a
              href="/articles"
              onClick={(e) => {
                e.preventDefault();
                onNavigate("/articles");
              }}
              className="text-sm text-muted-foreground no-underline transition-colors hover:text-foreground"
            >
              Articles
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
}
